<template>
  <v-card class="mt-0 pa-4" width="100%" outlined>
    <v-card-text width="100%" height="100%">
      <v-row align="center" justify="center">
        <v-col cols="3" >
          <h3>{{title}}</h3>
        </v-col>
        <v-col cols="9" >
          <slot ref="card"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props:{
    idCard:{
      type:Number
    },
    title:{
      type:String,
      default:''
    }
  },
  data(){
    return {
    }
  }
}
</script>